class FilterablePubSub {
    callbacks;
    constructor() {
        this.callbacks = [];
    }
    publish(topic, args) {
        this.callbacks
            .filter(({ filter }) => this.matchesFilter(filter, topic))
            .forEach(({ callback }) => callback(topic, args));
    }
    subscribe(filter, callback) {
        this.callbacks.push({ filter, callback });
    }
    unsubscribe(callback) {
        this.callbacks = this.callbacks.filter(({ callback: c }) => c !== callback);
    }
    matchesFilter(filter, topic) {
        // uses same format as https://www.npmjs.com/package/debug#wildcards
        if (filter.includes(",")) {
            const filterFragments = filter.split(",");
            const additiveFilters = filterFragments
                .filter((filterFragment) => !filterFragment.startsWith("-"))
                .map((f) => f.trim());
            const subtractiveFilters = filterFragments
                .filter((filterFragment) => filterFragment.startsWith("-"))
                .map((f) => f.trim().substring(1));
            const matchesAnyAdditiveFilter = additiveFilters.find((f) => this.matchesFilter(f, topic));
            const matchesAnySubtractiveFilter = subtractiveFilters.find((f) => this.matchesFilter(f, topic));
            return matchesAnyAdditiveFilter !== undefined && !matchesAnySubtractiveFilter;
        }
        const filterNamespaces = filter.split(":");
        const topicNamespaces = topic.split(":");
        return filterNamespaces
            .map((filterNamespace, index) => {
            if (filterNamespace === "*")
                return true;
            const topicNamespace = topicNamespaces[index];
            if (!topicNamespace)
                return false;
            if (filterNamespace === topicNamespace)
                return true;
        })
            .every(Boolean);
    }
}
export { FilterablePubSub };
